import { MessageInterceptor } from '@/context/MessageContext';

// 错误消息自动处理拦截器
export const errorInterceptor: MessageInterceptor = (content, type) => {
  console.log('errorInterceptor');
  if (type === 'error') {
    // 自动处理常见的错误消息格式
    if (content.includes('Network Error')) {
      return '网络连接失败，请检查网络设置';
    }
    if (content.includes('timeout')) {
      return '请求超时，请稍后重试';
    }
    if (content.includes('401')) {
      return '登录已过期，请重新登录';
    }
    if (content.includes('403')) {
      return '没有权限执行此操作';
    }
    if (content.includes('500')) {
      return '服务器内部错误，请联系管理员';
    }
  }
  return content;
};

// 敏感信息过滤拦截器
export const securityInterceptor: MessageInterceptor = (content) => {
  // 过滤密码、token等敏感信息
  const sensitivePatterns = [
    /password[^]*?=([^&]*)/gi,
    /token[^]*?=([^&]*)/gi,
    /authorization[^]*?=([^&]*)/gi,
  ];

  let filteredContent = content;
  sensitivePatterns.forEach((pattern) => {
    filteredContent = filteredContent.replace(pattern, '[敏感信息已过滤]');
  });

  return filteredContent;
};

// 长度限制拦截器
export const lengthInterceptor: MessageInterceptor = (content) => {
  const maxLength = 50;
  if (content.length > maxLength) {
    return `${content.substring(0, maxLength)}...`;
  }
  return content;
};

// 默认拦截器集合
export const defaultInterceptors = [securityInterceptor, errorInterceptor, lengthInterceptor];
